import React from 'react'
import { 
  Box, 
  Button, 
  Flex, 
  Heading, 
  Text, 
  VStack 
} from '@chakra-ui/react'
import { ErrorStateProps } from '../types'

const ErrorState: React.FC<ErrorStateProps> = ({ 
  error, 
  isRetrying, 
  onRetry, 
  subtitle, 
  title 
}) => {
  return (
    <Box p={4}>
      <Flex direction="column" mb={6}>
        <Heading as="h1" size="xl">{title}</Heading>
        <Text color="gray.500">{subtitle}</Text>
      </Flex>
      
      <VStack 
        align="center" 
        bg="red.50" 
        borderRadius="md" 
        color="red.600" 
        my={8} 
        p={8} 
        spacing={4}
      >
        <Text color="red.600" fontSize="5xl">⚠</Text>
        <Heading as="h3" size="md">Data Loading Error</Heading>
        <Text align="center">{error}</Text>
        <Button
          colorScheme="red"
          isLoading={isRetrying}
          leftIcon={<Text>↻</Text>}
          onClick={onRetry}
          variant="outline"
        >
          Retry
        </Button>
      </VStack>
    </Box>
  )
}

export default ErrorState
